import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import CryptoJS from "crypto-js";
import { caminhoDoLogo } from '../utils/caminhosConta';

export default function IsFinishedContainer() {
  const [logoCompanyUrl, setLogoCompanyUrl] = useState('');

  useEffect(() => {
    const resolveCompanyPath = () => {
      const pathParts = (window.location.pathname || '').split('/').filter(Boolean);
      return pathParts[0] || 'materdei';
    };

    const buildStorageLogoUrl = (bucket) => {
      if (!bucket) return '';
      const companyPath = resolveCompanyPath();
      const objectPath = caminhoDoLogo(companyPath);
      if (bucket.endsWith('firebasestorage.app')) {
        return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(objectPath)}?alt=media`;
      }
      return `https://storage.googleapis.com/${bucket}/${objectPath}`;
    };

    let cancelled = false;
    const params = new URLSearchParams(window.location.search);
    const encryptedData = params.get("data");
    if (encryptedData) {
      try {
        const secretKey = "due-prd"; 
        const decodedData = decodeURIComponent(encryptedData); 
        const decryptedBase64 = CryptoJS.AES.decrypt(decodedData, secretKey).toString(CryptoJS.enc.Utf8);
        const decryptedString = atob(decryptedBase64); 
        const decryptedParams = JSON.parse(decryptedString); 

        const logoUrl = decryptedParams.logoCompanyUrl;
        if (logoUrl) {
          setLogoCompanyUrl(logoUrl);
          return;
        }
      } catch (e) {
        console.error("Erro ao decodificar os parâmetros da URL", e);
      }
    }

    const fetchLogoUrl = async () => {
      const bucket = process.env.REACT_APP_STORAGE_BUCKET;
      const publicUrl = bucket ? buildStorageLogoUrl(bucket) : '';
      if (!cancelled) {
        if (publicUrl) {
          setLogoCompanyUrl(publicUrl);
        } else {
          console.error("Parâmetros não encontrados na URL");
        }
      }
    };

    fetchLogoUrl();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <EndContainer>
      {logoCompanyUrl ? (
        <img src={logoCompanyUrl} alt="Company Logo" onError={() => setLogoCompanyUrl('')} />
      ) : (
        <p>Logo não encontrada nos parâmetros da URL</p>
      )}
      <h1>Você já respondeu essa entrevista.</h1>
      <p>Para responder novamente contate sua equipe de Compliance.</p>
    </EndContainer>
  );
}

const EndContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #F8F9FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 25px;
  img {
    width: 250px;
    height: 250px;
    object-fit: contain;
  }
  h1 {
    font-size: 42px;
    color: #333;
    font-family: "Poppins", sans-serif;
  }
  p {
    font-size: 24px;
    color: #666;
    font-family: "Poppins", sans-serif;
    margin-top: 10px;
  }
`;
